export function SegmentedControl<T extends string | number>({
  options,
  value,
  onChange,
  label,
  className = '',
}: {
  options: readonly { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  label: string;
  className?: string;
}) {
  return (
    <div
      role="group"
      aria-label={label}
      className="seg min-w-0 max-w-full flex-wrap"
    >
      {options.map(opt => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          aria-pressed={value === opt.value}
          className={className}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
